import { render, staticRenderFns } from "./officialdetails.vue?vue&type=template&id=32c633ed&scoped=true"
import script from "./officialdetails.vue?vue&type=script&lang=js"
export * from "./officialdetails.vue?vue&type=script&lang=js"
import style0 from "./officialdetails.vue?vue&type=style&index=0&id=32c633ed&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c633ed",
  null
  
)

export default component.exports